import { EventRepository } from '~repositories/EventRepository';
import { events } from '@estee/elc-service-bus';
import { Event } from '~entities/Event';
import serviceNames from '~setup/AnalyticsService';
import { diContainer } from '~setup/diContainer';

export class StoreLocationSelectedUseCase {
    private eventRepository: EventRepository;
    private storeId: string;

    constructor(storeId: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.storeId = storeId;
    }

    public execute = async () => {
        const storeLocationSelectedPayload = {
            event_name: 'store location selected',
            event_action: 'store location selected',
            event_label: `store Id - $${this.storeId}`
        };

        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: events.STORE_LOCATION_SELECTED,
            type: 'link',
            payload: storeLocationSelectedPayload
        });

        this.eventRepository.addEventToQueue(newEvent);
    };
}
